import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    activeButton: "External Cash Deposit",
    externalCashDeposit: [],
    generateCashDepositCode: {
        flagCode: null,
    },
    newDepositRequest: {
        amount: null, 
        phoneNumber: "",
        firstName: "",
        lastName: "",
    },
};

const externalCashDepositSlice = createSlice({
    name: 'externalCash',
    initialState,
    reducers: {
        setActiveButton: (state, action) => {
            state.activeButton = action.payload;
        },
        setExternalCashDeposit: (state, action) => {
            state.externalCashDeposit = action.payload;
        },
        setGenerateCashDepositCode: (state, action) => {
            state.generateCashDepositCode = action.payload;
        },
        setNewDepositRequest: (state, action) => {
            state.newDepositRequest = { ...state.newDepositRequest, ...action.payload }; // Merge payload with the existing state
        },
        resetExternalCashDeposit: (state) => {
            state.externalCashDeposit = [];
            state.generateCashDepositCode = {
                flagCode: null,
            };
            state.newDepositRequest = {
                amount: null,
                phoneNumber: "",
                firstName: "",
                lastName: ""
            };
        },
        resetFlagCode: (state) => {
            state.generateCashDepositCode.flagCode = null;
        },
    },
});

export const {setActiveButton, setExternalCashDeposit, setGenerateCashDepositCode, setNewDepositRequest, resetExternalCashDeposit, resetFlagCode } = externalCashDepositSlice.actions;

export default externalCashDepositSlice.reducer;
